import React, { Component } from 'react'
import PropTypes from 'prop-types'

import AddCartWrapper from 'Catalog/Product/ProductDetail/RedemptionSection/AddCartWrapper'
import AddToCartButton from 'Checkout/Cart/AddToCartButton'
import ModalVoltage from 'Catalog/Product/ProductDetail/RedemptionSection/ModalVoltage'
import VerifyItemsCart from 'Catalog/Product/ProductDetail/RedemptionSection/VerifyItemsCart'

import { ChangeContext } from '../ChangeContext'
import { actions } from 'features/Cart'
import { connect } from 'react-redux'
import { Button } from 'loyal-react'
import yn from 'yn'

class AddCartVerify extends Component {
  constructor (props) {
    super()
    this.state = {
      showModalItemsCart: false
    }
    this.verifyItemsCart = this.verifyItemsCart.bind(this)
  }

  verifyItemsCart = () => {
    this.setState({ showModalItemsCart: !this.state.showModalItemsCart })
  }
  showModalCartPartner = () => {
    const { vendorId, items, onlyCash } = this.props
    return (yn(process.env.REACT_APP_HAS_VERIFY_CART_PARTNER) && onlyCash) && (items.length !== 0 && (items.length > 0 && vendorId !== (items[0].vendor.id).toString()))
  }
  render () {
    const { sku, vendorId, hasVoltage, changeContext, isLoading, wasModified } = this.props
    // Exibir mensagem que existem produtos no carrinho
    if (this.state.showModalItemsCart) {
      return <VerifyItemsCart verifyItemsCart={this.verifyItemsCart} showModalItemsCart sku={sku} vendorId={vendorId} goToCheckout className='btn-featured' />
    }
    // Exibir mensagem caso produto não pertença ao contexto
    if (changeContext) {
      return <ChangeContext />
    }
    const ready = !isLoading || wasModified
    if (ready) {
      return (
        <AddCartWrapper>
          {
            hasVoltage ? (
              <ModalVoltage
                sku={sku}
                vendorId={vendorId}
                verifyItemsCart={(this.showModalCartPartner()) ? this.verifyItemsCart : null} />
            ) : (
              this.showModalCartPartner() ? (
                <Button
                  className={`btn btn-sm txt-uppercase txt-center btn-featured`}
                  onClick={this.verifyItemsCart}
                  text={`Adicionar ao carrinho`}
                />
              ) : (
                <AddToCartButton
                  sku={sku}
                  vendorId={vendorId}
                  goToCheckout
                  className='btn-featured'
                />
              )
            )
          }
        </AddCartWrapper>
      )
    } else {
      return ''
    }
  }
}

AddCartVerify.propTypes = {
  sku: PropTypes.string,
  vendorId: PropTypes.string,
  hasVoltage: PropTypes.bool,
  changeContext: PropTypes.bool,
  isLoading: PropTypes.bool.isRequired,
  wasModified: PropTypes.bool.isRequired,
  items: PropTypes.array.isRequired,
  onlyCash: PropTypes.bool
}
const mapStateToProps = ({ cart, onlyCash }) => ({ ...cart, onlyCash })

const mapDispatchToProps = dispatch => ({
  loadCart: () => dispatch(actions.loadCart()),
  removeItem: sku => dispatch(actions.removeItem(sku))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddCartVerify)



// WEBPACK FOOTER //
// ./src/Catalog/Product/ProductDetail/RedemptionSection/AddCartVerify/index.js